// extracted by mini-css-extract-plugin
module.exports = {"header_box":"SDialogHeader_header_box__LUzuo","header":"SDialogHeader_header__2xOql","headBtn":"SDialogHeader_headBtn__SuiX9","title":"SDialogHeader_title__V_pFm"};